import React, { ChangeEvent } from "react";

interface Props {
  data: Record<string, string>;
  onEdit?: (updatedData: Record<string, string>) => void;
}

const ParameterTable: React.FC<Props> = ({ data, onEdit }) => {
  const keyValueArray = Object.entries(data);

  const handleEdit = (key: string, newValue: string) => {
    const updatedData = { ...data, [key]: newValue };
    if (onEdit) {
      onEdit(updatedData);
    }
  };

  return (
    <table className="min-w-full divide-y divide-gray-200 border">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Key
          </th>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Value
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {keyValueArray.map(([key, value], index) => (
          <tr key={index}>
            <td className="px-6 py-4 whitespace-nowrap">
              <div className="text-sm text-gray-900">{key}</div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
              <input
                type="text"
                value={value}
                className="text-sm text-gray-900 bg-white border border-gray-300 rounded px-2"
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  handleEdit(key, event.target.value)
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ParameterTable;
